import { createFileRoute } from "@tanstack/react-router";
import { seo, breadcrumbScript } from "@/lib/seo";
import { LegalCard, LegalPage } from "@/components/app/legal-page";

const DESC =
  "How The Quantum Minds collects, stores and protects your account information, study progress and payment data.";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    ...seo({
      title: "Privacy Policy — The Quantum Minds",
      description: DESC,
      path: "/privacy",
    }),
    scripts: [
      breadcrumbScript([
        { name: "Home", path: "/" },
        { name: "Privacy Policy", path: "/privacy" },
      ]),
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      intro="This page is maintained by The Quantum Minds to explain how your data is handled on this platform."
    >
      <LegalCard
        points={[
          "We collect only the information required to provide our services.",
          "User progress and account information are stored securely.",
          "Payment information is processed securely through Cashfree Payments.",
          "We do not sell personal information.",
          "Users may contact us regarding privacy concerns at thequantummindsofficial@gmail.com.",
        ]}
      />
    </LegalPage>
  );
}